import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-24 bg-cream-100" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 font-serif" data-id="element-4">
            ¿Es esto para ti?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-5">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-green-500" data-id="element-6">
            <h3 className="text-xl font-bold text-navy-900 mb-6 flex items-center" data-id="element-7">
              <CheckCircle className="w-6 h-6 text-green-500 mr-2" data-id="element-8" />
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-9">
              <li className="flex items-start" data-id="element-10">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-11" />
                <span className="text-navy-800/80" data-id="element-12">
                  Estás comprando casa en USA y quieres claridad YA.
                </span>
              </li>
              <li className="flex items-start" data-id="element-13">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-14" />
                <span className="text-navy-800/80" data-id="element-15">
                  Te da ansiedad que el número cambie a última hora.
                </span>
              </li>
              <li className="flex items-start" data-id="element-16">
                <span className="w-1.5 h-1.5 bg-green-500 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-17" />
                <span className="text-navy-800/80" data-id="element-18">
                  Quieres un sistema simple y práctico, no teoría financiera
                  aburrida.
                </span>
              </li>
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-red-400" data-id="element-19">
            <h3 className="text-xl font-bold text-navy-900 mb-6 flex items-center" data-id="element-20">
              <XCircle className="w-6 h-6 text-red-400 mr-2" data-id="element-21" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-22">
              <li className="flex items-start" data-id="element-23">
                <span className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-24" />
                <span className="text-navy-800/80" data-id="element-25">
                  Todavía estás a 12 meses o más de comprar (es muy pronto).
                </span>
              </li>
              <li className="flex items-start" data-id="element-26">
                <span className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-27" />
                <span className="text-navy-800/80" data-id="element-28">
                  Buscas consejos de inversión inmobiliaria avanzada.
                </span>
              </li>
              <li className="flex items-start" data-id="element-29">
                <span className="w-1.5 h-1.5 bg-red-400 rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-30" />
                <span className="text-navy-800/80" data-id="element-31">
                  Quieres que alguien "te diga qué hacer" sin que tú revises tus
                  documentos.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}